<div class="bmc-ldap-attributes">
    <div class="bmc-ldap-attributes__title">
        <label>{{ 'LDAP.MAPPING_TITLE' | translate }}</label>
    </div>
    <div class="bmc-ldap-attributes__add-panel">
        <label class="bmc-ldap-attributes__add-panel__text">{{ 'LDAP.TITLE_CONFIGURE' | translate }}</label>
        <bzg-button-primary icon="icon-plus" (click)="addMapping()">
            {{ 'LDAP.ADD_MAPPING' | translate }}
        </bzg-button-primary>
    </div>
    <div class="bmc-ldap-attributes__list">
        <div class="bmc-ldap-attributes__list__header">
            <label class="bmc-ldap-attributes__list__header__left">{{ 'LDAP.BIZAGI_ATTR' | translate }}</label>
            <label class="bmc-ldap-attributes__list__header__right">{{ 'LDAP.LDAP_ATTR' | translate }}</label>
        </div>
        <div *ngIf="isloading" class="bmc-ldap-security__loader">
            <bounce></bounce>
        </div>
        <ul class="bmc-ldap-attributes__list__items">
            <li *ngFor="let claim of claims" class="bmc-ldap-attributes__list__item">
                <bzg-select class="bmc-ldap-attributes__list__item__key bz-space--inline-m" [placeholder]="'LDAP.SELECT_ATTRIBUTE' | translate" [value]="claim.key" (valueChange)="changeValueMapping($event, claim.position)">
                    <bzg-option *ngFor="let item of userProperties" [value]="item">
                        {{item.value}}
                    </bzg-option>
                </bzg-select>
                <bzg-input class="bmc-ldap-attributes__list__item__value bz-space--inline-m" placeholder="{{ 'LDAP.TYPE_ATTRIBUTE' | translate }}" [(ngModel)]="claim.value" (change)="changeTextMapping($event.target.value, claim.position)"></bzg-input>
                <div class="bmc-ldap-attributes__list__item__delete-icon" (click)="deleteMapping(claim)">
                    <svg class="bz-icon-svg bz-icon-svg--16">
                        <use href="#icon-delete"></use>
                    </svg>
                </div>
            </li>
        </ul>
    </div>
</div>
